import React, { useEffect, useState } from 'react'
import { getObtenerTodasOpcionesCirugia, postBuscarPacientesEnUnaProgramacionModificar, postCirugiaQuirofano,  } from '../../../services/PaginaRuta';
import { fechaActual } from '../../../hooks/UseDate';
import Loading from '../../Loading';
import ModalProgramacionDeUnaCirugiaN from '../programacionDeUnaCirugia/ModalProgramacionDeUnaCirugiaN';
import ImprimirProgramacion from '../imprimirProgramacion/ImprimirProgramacion';
import TablaReservarCX from './TablaReservarCX';
import { useLocation } from 'react-router-dom';
import { UserTokenURL } from '../../../services/ApiHIS';
import axios from "axios";
import ErrorEndpointComponent from '../../Error/ErrorEndpointComponent';

const ReservarCX = () => {
  const [userDate, setUserDate] = useState([]);
  const [passActualizarTablaPacientes, setpassActualizarTablaPacientes]=useState({})
  const [modalOnProgramacionDeCirugia, setmodalOnProgramacionDeCirugia]=useState(false)
  const [modalOnImprimirProgramacion, setmodalOnImprimirProgramacion]=useState(false)
  const [loading, setLoading]=useState(false)
  const [errorEndpoint, seterrorEndpoint]=useState(false)
  const [dataQuirofanos, setdataQuirofanos]=useState([])
  const [dataOpcionCirugia, setdataOpcionCirugia]=useState([])

  //token
  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get('token'));
  let location = useLocation();
  //localStorage.removeItem('tokenReact');
  //localStorage.setItem('tokenReact',tokenCons)
  useEffect(() => {
    // Google Analytics
    localStorage.removeItem('tokenReact');
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

  //button para generar el PDF
  const handleOnclickImprimirProgramacion=()=>{
    setmodalOnImprimirProgramacion(true)
  }

  //cuando me llega la informacion de modificar una cirugia se actualiza
  const passDataActualizaTablaPacientes =(data)=>{
    setpassActualizarTablaPacientes(data)
  }

  //crear un paciente nuevo para realizar un procedimiento qx
  const handleOnclickModalOnProgramacionDeCirugia=()=>{
    setmodalOnProgramacionDeCirugia(true)
  }

  //filtros de busqueda
  const searchUserDateApi = (e) => {
    e.preventDefault();
    setLoading(false)
    //console.log(e.target.date.value,'fecha button')
    const body = { 
      ProFec:e.target.date.value,
      ProEmpCod:'1',
      ProSedQr:'001',
      MPCedu:e.target.userId.value,
      ProSit: e.target.opcion.value,
      ProCons: e.target.quirofano.value
    };
    postBuscarPacientesEnUnaProgramacionModificar(body).then((res)=>{
      console.log(res.data,'ulti')
      if(res.data){
        setTimeout(() => {          
          setLoading(true)
        }, 1000);
        let arrayUser = Object.values(res.data)        
        let filtradoEstadoSeis = arrayUser.filter(objeto => (parseInt(objeto.ProEsta) === 6) || (parseInt(objeto.ProEsta) === 1));
        setUserDate(Object.values(filtradoEstadoSeis))  
      }
    })
    .catch(error => {
      //console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
      setLoading(true)
    });
  }; 

  
  //token
  useEffect(()=>{
  
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL()
 
    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };
 

    // Realiza la petición con Axios
    axios.get(url, { headers })
    .then(response => {
      //console.log(response, 'data user');

      // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
      localStorage.removeItem('usuarioInfo');
      //console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
      // Guarda los nuevos datos
      localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

      //console.log(localStorage.getItem('usuarioInfo'),'antessss')
      // Comprobación de los datos almacenados
      //const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
      //console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr')

      // Resto del código...
    })
    .catch(error => {
      console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
    });
  },[])

  //cargar informacion de la tabla
  useEffect(()=>{    
    setLoading(false)
    const body={
      ProFec:fechaActual(),
      ProEmpCod:'1',
      ProSedQr:'001',
      ProCirCod:'',
      MPCedu:'',
      ProCons:''
    }     
        
    postBuscarPacientesEnUnaProgramacionModificar(body).then((res)=>{
      console.log(res.data,'dataultiumaaaaa')      
      if(res.data.error){
        setUserDate([])
        setLoading(true)
      }else{         
        setTimeout(() => {          
          setLoading(true)
        }, 1000);     
        let arrayUser = Object.values(res.data)       
        let filtradoEstadoSeis = arrayUser.filter(objeto => (parseInt(objeto.ProEsta) === 6) || (parseInt(objeto.ProEsta) === 1) || (parseInt(objeto.ProEsta) === 3));
        setUserDate(Object.values(filtradoEstadoSeis))        
      } 
    })
    .catch(error => {
      //console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
      setLoading(true)
    });
  },[passActualizarTablaPacientes])

  
  useEffect(()=>{

    getObtenerTodasOpcionesCirugia().then((res)=>{
      console.log(res.data.data)
      setdataOpcionCirugia(res.data.data)
    })
    
    postCirugiaQuirofano().then((res)=>{
      //console.log(res.data,'data quirofanos')
      setdataQuirofanos(res.data)
    })
  },[])

  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#9e56fe] font-medium pb-3">
          Reservar Cx
        </div>
        {/* <div className="text-center  pb-1">
          <label
            htmlFor="exampleFormControlInput1"
            className="form-label inline-block mt-1 text-black font-medium px-1 text-xl "
          >
            Programación de Cirugía - Imprimir Programación
          </label>
        </div> */}
        <div className="flex my-3">
        <div className="mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Programación de Cirugía
              </label>
              <div className="flex">
              <div className="">
                  <button
                    onClick={handleOnclickModalOnProgramacionDeCirugia}
                    type="button"
                    className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Programación
                  </button>
                </div>
              </div>
            </div>
            <div className="mb-3 xl:w-96 pl-5">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
              Imprimir Programación
              </label>
              <div className="flex">
              <div className="">
                  <button
                    onClick={handleOnclickImprimirProgramacion}
                    type="button"
                    className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Imprimir Programación
                  </button>
                </div>
              </div>
            </div>
            
            </div>

            {/* <div className="text-center  pb-1">
          <label
            htmlFor="exampleFormControlInput1"
            className="form-label inline-block mt-1 text-black font-medium px-1 text-xl "
          >
            Filtros de Búsqueda
          </label>
        </div> */}

        <form onSubmit={searchUserDateApi}>
          <div className="flex ">
            <div className="mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                N° documento identidad
              </label>
              <div className="flex">
                <input
                  name="userId"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-sm font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
            </div>
            <div  className="mb-3 xl:w-96 pl-2">
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium " >
                     Opción
                </label>
                <select className="form-select block  w-full px-2 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example " 
                //defaultValue={dataUser.ProSit}
                //value={opcion}
                //onChange={handleOnchangeOpcion} 
                name='opcion'
                >
                                         
                                        <option value="">Sin seleccionar</option>
                                        {
                                          dataOpcionCirugia.map((item)=>(
                                            <option value={item.PrcMulOpc} key={item.PrcMulOpc}>{item.PrcMulDsc}</option>
                                          ))
                                        }
                                       
                                    </select>
                                    
            </div>
            <div  className="mb-3 xl:w-96 pl-2">
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium " >
                     Quirófano
                </label>
                <select className="form-select block  w-full px-2 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example " 
                
                name='quirofano'
                >
                                        
                                        <option value="">Sin seleccionar</option>
                                        {
                                          dataQuirofanos.map((item,index)=>(
                                            <option value={item.ConsCod} key={index} className='text-sm'>{item.ConsDet}</option>
                                          ))
                                        }
                                    </select>
                                    
            </div>
            <div className="mb-3 pl-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Fecha
              </label>
              <div className="flex">
                <div className="flex items-center justify-center">
                  <div className="datepicker relative form-floating mb-3 xl:w-96">
                    <input
                      defaultValue={fechaActual()}
                      type="date"
                      name="date"
                      className="form-control block w-full px-3 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder="Select a date"
                    />
                  </div>
                </div>

                <div className="px-3">
                  <button
                    type="submit"
                    className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Buscar
                  </button>
                </div>
              </div>
            </div>
            
          </div>
          
                <div className="flex ">
            <div className="mb-3 xl:w-96 flex">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Varios procedimientos qx 
              </label>
              <div className="flex">
              <div className="px-2">
                    <input
                     
                      disabled={true}
                      type="text"
                      autoComplete="off"
                      className="form-control block w-20 px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#a7f3d0] bg-clip-padding    transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    
                  </div>
              </div>
            </div>
            <div  className="mb-3 xl:w-96 pl-2 flex">
            <div className="ml-2 h-6 w-6 rounded-full bg-blue-300 flex justify-center items-center text-blue-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">P</text>
  </svg>
</div>
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium pl-3" >
                     Programada
                </label>
                
                

                                    
            </div>
            <div  className="mb-3 xl:w-96 pl-2 flex">
            <div className="ml-2 h-6 w-6 rounded-full bg-red-300 flex justify-center items-center text-red-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">U</text>
  </svg>
</div> 
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium pl-3" >
                     Urgencias
                </label>
                
                

                                    
            </div>
            <div  className="mb-3 xl:w-96 pl-2 flex">
            <div className="ml-2 h-6 w-6 rounded-full bg-blue-400 flex justify-center items-center text-blue-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">A</text>
  </svg>
</div>
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium pl-3" >
                     Ambulatoria
                </label>
                
                

                                    
            </div>
            
          </div>

        </form>
        
        <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                    <th></th>
                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 "
                      >
                        Estado
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 "
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Modificar
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Agregar Paquetes Qx
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Consentimiento Informado
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        N° Cirugía
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Tipo Documento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        N° documento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Nombre
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Fecha
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Procedimiento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Hora Inicio
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Hora Final
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Teléfono
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Quirófano
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 "
                      >
                        Edad
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 "
                      >
                        Contrato
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 "
                      >
                        Cama
                      </th>
                    </tr>
                  </thead>
                  
                    {loading?
                    userDate.map((item, index) => (
                      <TablaReservarCX user={item} key={index} passDataActualizaTablaPacientes={passDataActualizaTablaPacientes}/>
                    )):
                    <tbody>
                    <tr className="divide-y divide-slate-700 ">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><Loading/></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    </tbody>
                  }
                  
                </table>
              </div>
            </div>
          </div>
        </div> 
      </div>
      {modalOnProgramacionDeCirugia? <ModalProgramacionDeUnaCirugiaN setmodalOnProgramacionDeCirugia={setmodalOnProgramacionDeCirugia} passDataActualizaTablaPacientes={passDataActualizaTablaPacientes}/>:null}
      {modalOnImprimirProgramacion? <ImprimirProgramacion setmodalOnImprimirProgramacion={setmodalOnImprimirProgramacion}/>:null}   
      {errorEndpoint && <ErrorEndpointComponent seterrorEndpoint={seterrorEndpoint} />}
    </>
  )
}

export default ReservarCX